import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SessionProvider } from './context/SessionContext';
import Landing from './components/Landing';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Profile from './components/Profile';
import ProfessionalValidation from './components/ProfessionalValidation';
import ProtectedRoute from './components/ProtectedRoute';
import UnauthorizedAccess from './components/UnauthorizedAccess';
import CommunityFeed from './components/CommunityFeed';
import Feed from './components/Feed';
import PageCommunityFeed from './pages/CommunityFeed';
import ResearcherDashboard from './components/ResearcherDashboard';
import Resources from './components/Resources';
import ResearcherLibrary from './pages/ResearcherLibrary';
import ScientificEvents from './pages/ScientificEvents';
import PersonalAgenda from './pages/PersonalAgenda';
import Community from './pages/Community';
import ResearcherPortal from './pages/ResearcherPortal';
import ProfileEdit from './components/ProfileEdit';
import ProfilePatient from './components/ProfilePatient';
import ProfilePatientEdit from './components/ProfilePatientEdit';
import ResearcherGroups from './pages/ResearcherGroups';
import ResearcherCommunity from './pages/ResearcherCommunity';
import ClinicalProjects from './pages/ClinicalProjects';
import ResearcherNetwork from './pages/ResearcherNetwork';
import MessengerChat from './components/MessengerChat';
import PatientGroups from './pages/PatientGroups';
import PatientNetwork from './pages/PatientNetwork';
import PatientAI from './pages/PatientAI';
import GrantsPage from './pages/Grants';
import ScientificSearch from './pages/ScientificSearch';
import ScientificArticleDetail from './pages/ScientificArticleDetail';
// Import other components as needed...

import { ScientificProvider } from './context/ScientificContext';

function App() {
  return (
    <SessionProvider>
      <AuthProvider>
        <ScientificProvider>
          <Router>
        <Routes>
          {/* Rutas Públicas - Accesibles sin autenticación */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Rutas Protegidas - Requieren autenticación */}
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />

          <Route path="/profile/edit" element={
            <ProtectedRoute>
              <ProfileEdit />
            </ProtectedRoute>
          } />

          <Route path="/profile-patient" element={
            <ProtectedRoute>
              <ProfilePatient />
            </ProtectedRoute>
          } />

          <Route path="/profile-patient/edit" element={
            <ProtectedRoute>
              <ProfilePatientEdit />
            </ProtectedRoute>
          } />

          <Route path="/validate" element={
            <ProtectedRoute roles={['HEALTH_PROFESSIONAL', 'INVESTIGATOR']}>
              <ProfessionalValidation />
            </ProtectedRoute>
          } />

          <Route path="/community-feed" element={
            <ProtectedRoute>
              <PageCommunityFeed />
            </ProtectedRoute>
          } />

          <Route path="/feed" element={
            <ProtectedRoute>
              <Feed />
            </ProtectedRoute>
          } />

          <Route path="/researcher-community" element={
            <ProtectedRoute roles={['INVESTIGATOR']}>
              <ResearcherCommunity />
            </ProtectedRoute>
          } />

          <Route path="/researcher-groups" element={
            <ProtectedRoute roles={['INVESTIGATOR']}>
              <ResearcherGroups />
            </ProtectedRoute>
          } />

          <Route path="/groups" element={
            <ProtectedRoute>
              <PatientGroups />
            </ProtectedRoute>
          } />

          <Route path="/resources" element={<Resources />} />
          <Route path="/scientific-events" element={<ScientificEvents />} />
          <Route path="/personal-agenda" element={<PersonalAgenda />} />
          <Route path="/researcher-library" element={<ResearcherLibrary />} />
          <Route path="/community" element={<Community />} />
          <Route path="/researcher-portal" element={
            <ProtectedRoute roles={['INVESTIGATOR']}>
              <ResearcherPortal />
            </ProtectedRoute>
          } />

          <Route path="/clinical-projects" element={
            <ProtectedRoute roles={['INVESTIGATOR']}>
              <ClinicalProjects />
            </ProtectedRoute>
          } />

          <Route path="/researcher-network" element={
            <ProtectedRoute roles={['INVESTIGATOR']}>
              <ResearcherNetwork />
            </ProtectedRoute>
          } />
          
          <Route path="/community-page" element={
            <ProtectedRoute>
              <PageCommunityFeed />
            </ProtectedRoute>
          } />

          <Route path="/patient-network" element={
            <ProtectedRoute>
              <PatientNetwork />
            </ProtectedRoute>
          } />

          <Route path="/chat" element={
            <ProtectedRoute>
              <MessengerChat />
            </ProtectedRoute>
          } />

          <Route path="/patient-ai" element={
            <ProtectedRoute>
              <PatientAI />
            </ProtectedRoute>
          } />
          
          <Route path="/grants" element={
            <ProtectedRoute>
              <GrantsPage />
            </ProtectedRoute>
          } />

          <Route path="/scientific-search" element={
            <ProtectedRoute>
              <ScientificSearch />
            </ProtectedRoute>
          } />

          <Route path="/scientific-article/:id" element={
            <ProtectedRoute>
              <ScientificArticleDetail />
            </ProtectedRoute>
          } />

          {/* Rutas de control de acceso */}
          <Route path="/unauthorized" element={<UnauthorizedAccess />} />

          {/* Catch-all: Cualquier otra ruta redirige a Landing */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
        </ScientificProvider>
      </AuthProvider>
    </SessionProvider>
  );
}

export default App;
